import LogoIntro from './LogoIntro';
import HeroBanner from './HeroBanner';
import ContactForm from './ContactForm';
import AboutUs from './AboutUs';
import OtherProductsGap from './OtherProductsGap';
import ProductSection from './ProductSection';
import Footer from './Footer';
import Navbar from './Navbar';

export default function LandingPage() {
    return (
      <>
        <Navbar />
        <div id="home"></div>
        <LogoIntro />
        {/* <div id="hero"></div> */}
        <div id="products"></div>
        <ProductSection />
        <HeroBanner />
        <div id="contact"></div>
        <ContactForm />
        <div id="aboutus"></div>
        <AboutUs />
        <OtherProductsGap />
        
        <Footer />
      </>
    );
  }
  